var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInforCast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.16,
    height: 26.397,
    viewBox: "0 0 21.16 26.397",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95",
    transform: "translate(-6004.115 -6583.227)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    cx: 5.248,
    cy: 5.248,
    r: 5.248,
    transform: "translate(6009.447 6583.227)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M6025.275,6605.835a10.58,10.58,0,0,0-10.778-10.578,10.811,10.811,0,0,0-10.382,10.929v2.37a1.067,1.067,0,0,0,1.067,1.068h19.026a1.068,1.068,0,0,0,1.067-1.068Z",
    fill: "#1a1a1a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInforCast);
export default __webpack_public_path__ + "static/media/iconInforCast.3e6f3834b1bb518b0ec243f149f2e69e.svg";
export { ForwardRef as ReactComponent };